module.exports = __webpack_public_path__ + "img/number_3.937a9370.png";